import { useGetMeeting } from "@/hooks/queryHooks/meetingHooks";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { Button } from "@repo/ui/components/Base/Button";
import { useNavigate } from "react-router-dom";

export const MeetingDisplay = ({
  tenantId,
  meetingId,
}: {
  tenantId: string;
  meetingId: string;
}) => {
  const navigate = useNavigate();

  const { data: meeting } = useGetMeeting(tenantId, meetingId);

  const handleView = () => {
    const appUrlPath = new AppUrlPath(tenantId);
    navigate(appUrlPath.getMeetingPath(meetingId));
  };

  return (
    <div className="p-2 mb-2 bg-secondary bg-opacity-75 rounded-lg text-secondary-foreground">
      <div className="flex flex-row justify-between items-center gap-x-2">
        <h3 className="text-lg">{meeting?.name ?? "..."}</h3>
        <Button type="button" onClick={() => handleView()}>
          View
        </Button>
      </div>
    </div>
  );
};
